import { useEffect, useRef } from "react";

// Adds .in class when a .reveal element enters viewport.
// Uses a MutationObserver so async-loaded content (e.g. team members
// fetched after mount) is also observed and revealed correctly.
export default function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    const observeAll = () => {
      el.querySelectorAll(".reveal:not(.in)").forEach((t) => io.observe(t));
    };

    observeAll();

    const mo = new MutationObserver(observeAll);
    mo.observe(el, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);
  return ref;
}
